import * as types from './actionTypes';  
import followerListApi from '../api/followerListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchFollowerList(ext_id, email) {

  return {
    type: types.DO_FETCH_FOLLOWER_LIST, 
    ext_id,
    email
  };
}

export function doFetchFollowerListRes(data) {  
  return {
    type: types.DO_FETCH_FOLLOWER_LIST_RES, 
    data
  };
}

export function getFollowerList(ext_id, email) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      followerListApi.doFetchFollowerList(ext_id, email).then(data => {
        dispatch(doFetchFollowerListRes(data));
        dispatch(doFetchFollowerListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}